import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import { PieChart, Pie, Cell } from "recharts";
import theme from "../../theme";
import "../ChartComponents/chartStyles.css";

const HealthScoreBar = ({ data}) => {
  const bgColor = useColorModeValue("#F9F9FB", "#4B5871");
  const chartColors = Object.values(theme.colors.chartColors);
  const textColor = useColorModeValue("chart-title-dark", "chart-title");
  return (
    <Box backgroundColor={bgColor} className="health-box">
      <PieChart width={300} height={150}>
        <Pie
          data={data}
          startAngle={180}
          endAngle={0}
          cx="50%"
          cy="75%" // Adjusted to make space for the text at the center
          innerRadius={60}
          outerRadius={100}
          dataKey="value"
          stroke="none"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={chartColors[index % chartColors.length]}
            />
          ))}
        </Pie>
      </PieChart>

      <Box
        position="absolute"
        top="70%"
        left="50%"
        transform="translate(-50%, -50%)"
        fontSize="14px"
        fontWeight="bold"
        textAlign="center"
        textColor={textColor}
      >
        {/*TODO: needs update:*/}
        {data[0].value}%
        <br />
        <span style={{  fontSize: '12px', fontWeight: '600' }}>Health Score</span>
      </Box>
      <Box
        position="absolute"
        top="70%" // Align with the pie chart
        left="36px" // 0 positioned to the left
        fontSize="10px"
        fontWeight="700"
      >
        0
      </Box>
      <Box
        position="absolute"
        top="70%" // Align with the pie chart
        right="25px" // 100 positioned to the right
        fontSize="10px"
        fontWeight="700"
      >
        100
      </Box>
    </Box>
  );
};

export default HealthScoreBar;
